/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_No_UsersInputs */

const en_user_no_users = /** @type {(inputs: User_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found`)
};

const ja_user_no_users = /** @type {(inputs: User_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーが見つかりません`)
};

const fr_user_no_users = /** @type {(inputs: User_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun utilisateur trouvé`)
};

const de_user_no_users = /** @type {(inputs: User_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Benutzer gefunden`)
};

/**
* | output |
* | --- |
* | "No users found" |
*
* @param {User_No_UsersInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_no_users = /** @type {((inputs?: User_No_UsersInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_No_UsersInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_no_users(inputs)
	if (locale === "ja") return ja_user_no_users(inputs)
	if (locale === "fr") return fr_user_no_users(inputs)
	return de_user_no_users(inputs)
});